import type { GraphRowClassName } from 'features/RiskManagement/Components/Graphs/Layout/GraphGrid'

export enum RiskForecastGraphs {
  Total,
  ByThreat
}

export const getRiskForecastRowClassName = (
  graphType: RiskForecastGraphs
): GraphRowClassName => {
  return graphType === RiskForecastGraphs.Total ? 'forecastTotal' : 'forecast'
}
